<template>
    <template v-if="isCommunity">
        <Teleport defer to="#portalNotifications" v-if="isCommunityInit">
            <div class="dropdown-item" v-for="notification in notifications"
              @click.prevent="handleClick($event, notification)"
              :class="{unread: notification.data.read === 'N', useHand: (notification.data.title.includes('<a href') || notification._meta?.href) }"
            >
                <div class="inner">
                <div class="title" v-html="trans(notification.data.title)"></div>
                <div class="time">
                    <span class="label"><timeago :datetime="new Date(notification.data.date_publish)"/></span>
                    <Icon name="clock" />
                </div>
                </div>
            </div>
        </Teleport>
    </template>
    <template v-else>
        <el-dropdown :class="classes" placement="top-end" size="large" @visible-change="handleChange">
            <template #default>
                <button type="button" class="inner">
                    <Icon name="notification" />
                    <span class="title">{{ trans("Notificaties") }}</span>
                </button>
            </template>
            <template #dropdown>
                <el-dropdown-menu>
                    <template v-if="notifications.length">
                        <el-dropdown-item v-for="notification in notifications"
                              class="dropdown-item"
                              @click.prevent="handleClick($event, notification)"
                              :class="{unread: notification.data.read === 'N', useHand: (notification.data.title.includes('<a href') || notification._meta?.href) }"
                        >
                            <div class="inner">
                                <div class="title" v-html="trans(notification.data.title)"></div>
                                <div class="time">
                                    <span class="label"><timeago :datetime="new Date(notification.data.date_publish)"/></span>
                                    <Icon name="clock" />
                                </div>
                            </div>
                        </el-dropdown-item>
                    </template>
                    <template v-else-if="loading">
                        <el-dropdown-item>
                            {{ trans("Aan het laden...") }}
                        </el-dropdown-item>
                    </template>
                    <template v-else>
                        <el-dropdown-item>
                            {{ trans("Er zijn nog geen notificaties") }}
                        </el-dropdown-item>
                    </template>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
    </template>
</template>

<script>
import {defineComponent, computed, onMounted, reactive, ref, inject, onBeforeUnmount, watch } from "vue";
import {useRoute, useRouter} from "vue-router";

// Our helpers
import {apiHostname} from "config";
import trans, {locale} from "helpers/_translation";
import {getDataAsync, patchDataAsync, getCurrentDateFilters} from "helpers/_api";
import { fetchItem, item } from "store/portal";

import Dropdown from "components/dropdown.vue";
import Icon from "components/icon";

import { addNotification } from "store/notifications";

export default defineComponent({
    name: "notification-dropdown",
    props: {},
    components: {
        Dropdown,
        Icon
    },
    setup(props) {

        const isCommunity = inject("isCommunity");
        const isCommunityInit = ref(false);

        const route = useRoute();
        const router = useRouter();

        const LIMIT = 9999;
        const REFRESH_SECONDS = 60;

        const LOAD_UNREAD_KEY = "notification-initial-unread";

        const componentData = reactive({
            loading: true,
            initial_unread: false,
            data: [],
            last_opened: localStorage.getItem('lastOpenedNotifications') ?? null
        });
        const hasUnread = computed(() => {
            let data = [...componentData.data];
            if (componentData.last_opened) {
                data = data.filter(a => {
                    return (new Date(a.data.date_publish)) > (new Date(componentData.last_opened));
                });
            }
            const result = data.some(a => a.data.read === 'N');
            if (result) {
                sessionStorage.setItem(LOAD_UNREAD_KEY, result);
                componentData.initial_unread = true;
            }
            return result;
        });


        let latest_filters = null;
        const fetchData = () => {
            const filters = [];
            // getCurrentDateFilters
            if (latest_filters) {
                filters.push(...latest_filters.future);
            }

            getDataAsync(`${apiHostname}/api/v1.0/notification?limit=${LIMIT}&seq=date_publish`, filters).then(json => {
                componentData.loading = false;
                const allData = [...json.data, ...componentData.data];
                const newData = [];
                allData.map(x => newData.filter(a => a.id == x.data.id).length > 0 ? null : newData.push(x));
                componentData.data = newData;
                latest_filters = getCurrentDateFilters();
            });
        };


        const notifications = computed(() => {
            return componentData.data.slice(0, LIMIT);
        });

        const handleConfirm = inject("handleConfirm");
        const handleItemClick = (e, payload) => {
            const payloadData = btoa(JSON.stringify(payload));
            router.push(`/${route.path.split("/")[1]}/${payloadData}`);
        };
        const handleClick = (e, notification) => {
            handleConfirm().then(
                () => {

                    // Check if there is a <A within the notification
                    // KEEP THIS, BUT UNUSED AT THE MOMENT
                    // let url = notification._meta?.href || "";
                    // const target = e.currentTarget || e.target;
                    // const link = target.querySelector('a');
                    // link && (url = link.href);

                    if (notification.data?.module_object === "Workflowcard") {
                        const targetId = notification.data.item_id;
                        fetchItem("workflowcard", targetId);
                        // Added watcher
                        let targetWatcher;
                        targetWatcher = watch(
                            () => item("workflowcard", targetId),
                            (a) => {
                                if (!a?.extra?.workflowboard?.id) return;

                                const formData = new FormData();
                                formData.set("read", "Y");
                                patchDataAsync(`${apiHostname}/api/v1.0/notification/${notification.data.id}`, formData).then(json => {
                                    notification.data.read = "Y";
                                    // HANDLE CLICK
                                    console.log("Handle Notification click",notification.data);

                                    if (a?.data?.state !== "Online") {
                                        addNotification(trans("Dit item is niet meer te vinden"), 3500);
                                        return;
                                    }
                                    const params = {
                                        workflowboard_id: `${a.extra.workflowboard.id}`,
                                        workflowphase_id: null,
                                        workflowcard_id: targetId
                                    };
                                    handleItemClick(e, params);
                                });

                                targetWatcher && targetWatcher();
                            },
                            {
                                immediate: true,
                                deep: true
                            }
                        );

                    }
                },
                () => {
                    // Rejected
                }
            )
        };

        const storeDate = () => {
            // Update storage value
            const currentDateObject = new Date();
            const currentDate = `${currentDateObject.toISOString().split('T')[0]} ${currentDateObject.toLocaleTimeString(locale)}`;
            componentData.last_opened = currentDate;
            localStorage.setItem('lastOpenedNotifications', currentDate);
        };
        const handleDropdownOpen = () => {
            // Load data since it is async now
            fetchData();
            // Set last opened data to filter for new items
            storeDate();
            // Reset initial unread
            componentData.initial_unread = false;
            sessionStorage.removeItem(LOAD_UNREAD_KEY);
        };
        const handleDropdownClose = () => {
            storeDate();
        };

        const handleChange = (visible) => {
            visible ? handleDropdownOpen() : handleDropdownClose();
        };


        const classes = computed(() => {
            return {
                "elementNotifications": true,
                "newitem": (componentData.initial_unread || hasUnread.value)
            }
        });

        const loading = computed(() => componentData.loading);

        const notificationTarget = document.querySelector(".notificationsComponent");
        let observer = null;

        onMounted(() => {
            componentData.initial_unread = sessionStorage.getItem(LOAD_UNREAD_KEY) || false;
            !componentData.initial_unread && setTimeout(fetchData, 5000);
            // Fetch items every 30 seconds
            setInterval(() => {
                if (componentData.initial_unread || hasUnread.value) return;
                fetchData();
            }, REFRESH_SECONDS * 1000);


            // Observe mutations
            if (isCommunity.value) {
                observer = new MutationObserver((mutationsList) => {
                    if (!notificationTarget.querySelector("#portalNotifications")) return;
                    isCommunityInit.value = true;
                    watch(
                        () => notifications.value,
                        () => {
                            if (!notifications.value.length) return;
                            const elementTarget = notificationTarget.querySelector(".elementNotifications");
                            elementTarget && elementTarget.classList.add("newitem");
                        },
                        {
                            immediate: true
                        }
                    )
                    observer && observer?.disconnect() && (observer = null);
                });
                if (notificationTarget) {
                    observer.observe(notificationTarget, {childList: true, subtree: true});
                }
            }
        });
        onBeforeUnmount(() => {
            observer && observer?.disconnect();
        });

        return {
            isCommunity,
            isCommunityInit,

            trans,
            hasUnread,
            componentData,

            loading,
            classes,
            notifications,
            handleClick,

            handleChange
        }
    },
});
</script>

<style>
</style>